import { Link } from '@chakra-ui/next-js';
import { ContainerProps, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { brand } from '@/shared/constants';
import { LocalprofLogo } from '@/shared/ui';

interface ILogoLinkProps extends ContainerProps {
  clickable?: boolean;
}

const LogoLink: FC<ILogoLinkProps> = ({ clickable = true, ...props }) => {
  const { t } = useTranslation();

  return (
    <Flex
      _hover={{
        transform: clickable ? 'scale(1.01)' : 'none',
      }}
      alignItems='center'
      as={clickable ? Link : 'span'}
      gap='sm'
      href='/'
      {...props}
    >
      <LocalprofLogo
        aria-label={t('common.header.home')}
        boxSize={8}
      />
      <Text
        display={{ base: 'none', md: 'block' }}
        fontSize='xl'
        fontWeight='semibold'
      >
        {brand}
      </Text>
    </Flex>
  );
};

export default LogoLink;
